<template>
  <div class="row mb-3">
    <div class="col-4">
      <div class="label">โครงการ</div>
      <project-select :value="value.project" @input="handleChangeProject"></project-select>
    </div>
    <div class="col-4">
      <div class="label">บ้าน</div>
      <el-select
        :value="homeValues"
        :filter-method="handleFilterHomes"
        class="select"
        filterable
        clearable
        multiple
        placeholder="เลือกบ้าน"
        value-key="homeId"
        @input="handleChangeHomes"
      >
        <el-option
          v-for="home in projectHomeOptions"
          :key="home.homeId"
          :value="home.homeId"
          :label="home.addressNo || home.plotCode"
        ></el-option>
      </el-select>
    </div>
    <div class="col-4">
      <div class="label">ฐานะ</div>
      <el-select
        :value="value.role"
        class="select"
        clearable
        placeholder="เลือกฐานะ"
        @input="handleChangeRole"
      >
        <el-option
          v-for="role in roleOptions"
          :key="role.value"
          :value="role.value"
          :label="role.label"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import ProjectSelect from "@/lib/components/ProjectSelect";
import { userRoleMapper } from "@/lib/mapper";

import { Option, Select } from "element-ui";
import { isEmpty } from "ramda";

export default {
  components: {
    ProjectSelect,
    "el-select": Select,
    "el-option": Option
  },
  props: {
    value: { type: Object, required: true }
  },
  data() {
    return {
      projectHomes: [],
      projectHomeByIds: {},
      homeQuery: "",
      roleOptions: Object.keys(userRoleMapper).map(key => ({
        value: key,
        label: userRoleMapper[key]
      }))
    };
  },
  computed: {
    projectHomeOptions() {
      if (!this.homeQuery) {
        return this.projectHomes;
      }

      return this.projectHomes.filter(home => {
        if (isEmpty(home.addressNo)) {
          return (home.plotCode || "").includes(this.homeQuery);
        }

        return home.addressNo.includes(this.homeQuery);
      });
    },
    homeValues() {
      return this.value.homes.map(({ homeId }) => homeId);
    }
  },
  watch: {
    "value.project": function watchValueProject(newVal, oldVal) {
      if (newVal === null) {
        this.resetForm();
        return;
      }

      if (oldVal !== null && newVal.projectId === oldVal.projectId) {
        return;
      }

      this.updateProjectHomes();
    }
  },
  methods: {
    async updateProjectHomes() {
      try {
        const result = await this.fetchProjectHomes();

        this.projectHomes = result;
        this.projectHomeByIds = result.reduce(
          (all, home) => ({ ...all, [home.homeId]: home }),
          {}
        );
      } catch (error) {
        this.projectHomes = [];
        this.projectHomeByIds = {};
        this.$message.error("ไม่สามารถโหลดรายการบ้านได้");
      }

      this.homeQuery = "";
      this.$emit("input", { ...this.value, homes: [], role: null });
    },
    async fetchProjectHomes() {
      const { projectId } = this.value.project;

      const response = await baanRueJaiClient.admin.memberManagement.projects.homes(
        projectId
      );

      return response.data;
    },
    handleFilterHomes(query) {
      this.homeQuery = query;
    },
    handleChangeProject(project) {
      this.$emit("input", { ...this.value, project });
    },
    handleChangeRole(role) {
      this.$emit("input", { ...this.value, role });
    },
    handleChangeHomes(homeIds) {
      this.$emit("input", {
        ...this.value,
        homes: homeIds.map(id => this.projectHomeByIds[id])
      });
    },
    resetForm() {
      this.$emit("input", {
        ...this.value,
        homes: [],
        role: null,
        project: null
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  width: 100%;
}
</style>
